import React, { useEffect, useState, useRef } from "react";
import { Flex } from "antd";
import { Link, useLocation } from "react-router-dom";

const CATEGORY = [
    { value: "proposal-upload", label: "제안서", path: "/onandme/proposal" },
    { value: "list-2d", label: "키비주얼", path: "/onandme/list/2d" },
    { value: "list-3d", label: "3D", path: "/onandme/list/3d" },
    { value: "qrEvent-venue", label: "행사장", path: "/onandme/event-venue" },
    { value: "nara", label: "나라장터 검색", path: "/" },
];

export default function OnandmeHeader() {
    // 세션 만료 타이머
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        let timerId;
        function updateTimeLeft() {
            const exp = Number(localStorage.getItem("auth_token_exp"));
            if (!exp) {
                setTimeLeft(null);
                return;
            }
            const now = Date.now();
            const diff = Math.max(0, exp - now);
            setTimeLeft(diff);

            if (diff > 0) {
                timerId = setTimeout(updateTimeLeft, 1000);
            }
        }
        updateTimeLeft();
        return () => timerId && clearTimeout(timerId);
    }, []);

    const handleExtendSession = async () => {
        const ok = window.confirm("로그인 시간을 연장하시겠습니까?");
        if (!ok) return;

        try {
            const token = localStorage.getItem("auth_token");
            const res = await fetch(
                `${process.env.REACT_APP_API_REAL_URL}/auth/extend`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-TOKEN": token,
                    },
                }
            );
            const data = await res.json();
            if (data.expiration) {
                localStorage.setItem("auth_token_exp", data.expiration.toString());
                setTimeLeft(data.expiration - Date.now());
                alert("로그인 시간이 연장되었습니다.");
            } else {
                alert("세션 연장에 실패했습니다.");
            }
        } catch (e) {
            alert("세션 연장에 실패했습니다.");
        }
    };

    const renderTimeLeft = () => {
        if (timeLeft == null) return null;
        const totalSec = Math.floor(timeLeft / 1000);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        return `${min}분 ${sec}초`;
    };

    const location = useLocation();

    // ▼▼▼ 드롭다운 관련 state & ref ▼▼▼
    const [isPosterOpen, setIsPosterOpen] = useState(false);
    const dropdownRef = useRef(null);

    // (옵션) 드롭다운 바깥을 클릭하면 닫기
    useEffect(() => {
        function handleClickOutside(e) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target)
            ) {
                setIsPosterOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 1,
                right: 24,
                zIndex: 30,
                borderRadius: 12,
                padding: "16px 24px",
                width: "100%",
                backgroundColor: "white",
            }}
        >
            <Flex justify="end" align="center" gap={24}>
                {/* 남은 세션 시간 */}
                <span
                    className="text-blue-600 cursor-pointer select-none"
                    title="로그인 세션 남은 시간"
                    onClick={handleExtendSession}
                >
                    {renderTimeLeft()}
                </span>

                {/* 드롭다운 메뉴 */}
                <li
                    className="relative list-none"
                    ref={dropdownRef}
                    style={{ fontSize: 20 }}
                >
                    <div
                        className="hover:text-blue-600 transition cursor-pointer"
                        onClick={() => setIsPosterOpen(!isPosterOpen)}
                    >
                        업로드 ▼
                    </div>

                    {isPosterOpen && (
                        <ul className="absolute left-0 mt-2 w-52 bg-white border rounded shadow-lg z-50 text-sm py-2">
                            <li>
                                <a
                                    href="/onandme/proposal/upload"
                                    className="block px-4 py-2 hover:bg-gray-100"
                                >
                                    제안서 업로드
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/onandme/upload/2d"
                                    className="block px-4 py-2 hover:bg-gray-100"
                                >
                                    키비주얼 업로드
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/onandme/upload/3d"
                                    className="block px-4 py-2 hover:bg-gray-100"
                                >
                                    3D 업로드
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/onandme/upload/qrEvent-venue/"
                                    className="block px-4 py-2 hover:bg-gray-100"
                                >
                                    행사장 업로드
                                </a>
                            </li>
                        </ul>
                    )}
                </li>

                {/* 기존 CATEGORY 링크 */}
                {CATEGORY.map((category) =>
                    category.value === "nara" ? (
                        <a
                            key={category.value}
                            href={category.path}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                textDecoration: "none",
                                color: "#333",
                                fontWeight: 500,
                                fontSize: 25,
                                padding: "4px 8px",
                                borderRadius: 4,
                                transition: "color 0.15s, background 0.15s",
                            }}
                            className="onandme-header-link"
                        >
                            {category.label}
                        </a>
                    ) : (
                        <Link
                            key={category.value}
                            to={category.path}
                            style={{
                                textDecoration: "none",
                                color:
                                    location.pathname === category.path
                                        ? "#1677ff"
                                        : "#333",
                                fontWeight: 500,
                                fontSize: 25,
                                padding: "4px 8px",
                                borderRadius: 4,
                                transition: "color 0.15s, background 0.15s",
                            }}
                            className="onandme-header-link"
                        >
                            {category.label}
                        </Link>
                    )
                )}


            </Flex>

            <style>{`
                .onandme-header-link:hover {
                    color: #1677ff !important;
                    background: #e6f4ff;
                }
            `}</style>
        </div>
    );
}